import { useMemo } from "react";
import usePermissions from "./usePermissions";

const useSortedProviderTeams = () => {
  const { permissions } = usePermissions();
  const sortedTeams = useMemo(() => {
    const teams = JSON.parse(permissions || "{}")?.provider_teams?.teams;
    if (!teams || !teams?.length) {
      return [];
    }
    return [...teams].filter((team) => team.is_active).sort((a, b) => a.label.localeCompare(b.label));
  }, [permissions]);

  return sortedTeams;
};

export default useSortedProviderTeams;
